import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Location
import LocationImage from 'components/location/image';
import BookAgain from 'components/location/buttons/book-again';

// Bookings
import ViewReceipt from 'components/bookings/buttons/view-receipt';
import RateLocation from 'components/bookings/rate-location';

import BookingModel from 'models/booking';
import { Location as LocationModel } from 'models/locations';
import Brand from 'models/brand';
import Review from 'models/review';

import BrandName from 'containers/common/brand-name';
import VisibilitySensor from 'react-visibility-sensor';
import { pageProps } from 'lib/analytics/page-properties';
import { BUTTON_IMPRESSION, BUTTON_CLICK } from 'lib/analytics/events';

const propTypes = {
  booking: PropTypes.instanceOf(BookingModel).isRequired,
  location: PropTypes.instanceOf(LocationModel).isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  review: PropTypes.instanceOf(Review),
  reviewBooking: PropTypes.func.isRequired,
  app: PropTypes.string.isRequired,
  trackEvent: PropTypes.func.isRequired,
  analyticsPosition: PropTypes.number,
  selected: PropTypes.bool,
};

const defaultProps = {
  review: null,
  analyticsPosition: 0,
  selected: false,
};

class Details extends Component {
  constructor(props) {
    super(props);

    this.onBookNowVisibilityChange = this.onBookNowVisibilityChange.bind(this);
    this.onBookNowClick = this.onBookNowClick.bind(this);
    this.onViewReceiptVisibilityChange = this.onViewReceiptVisibilityChange.bind(this);
    this.onViewReceiptClick = this.onViewReceiptClick.bind(this);
    this.onRateVisibilityChange = this.onRateVisibilityChange.bind(this);
    this.onRateClick = this.onRateClick.bind(this);
  }

  onBookNowVisibilityChange(isVisible) {
    const { trackEvent, app, location, booking, analyticsPosition } = this.props;
    if (isVisible) {
      const pageProperties = pageProps({
        app,
        LocationID: location.id,
        LocationAddress: location.address,
        StateTime: booking.startTime,
        Departure: booking.endTime,
        Total: booking.pricePaid,
        PurchasedDate: booking.purchasedAt,
      });
      trackEvent({
        ...BUTTON_IMPRESSION,
        ...pageProperties,
        name: 'BookAgain',
        position: analyticsPosition.toString(),
      });
    }
  }

  onBookNowClick() {
    const { trackEvent, app, location, booking, analyticsPosition } = this.props;
    const pageProperties = pageProps({
      app,
      LocationID: location.id,
      LocationAddress: location.address,
      StateTime: booking.startTime,
      Departure: booking.endTime,
      Total: booking.pricePaid,
      PurchasedDate: booking.purchasedAt,
    });
    trackEvent({
      ...BUTTON_CLICK,
      ...pageProperties,
      name: 'BookAgain',
      position: analyticsPosition.toString(),
    });
  }

  onViewReceiptVisibilityChange(isVisible) {
    const { trackEvent, app, analyticsPosition } = this.props;
    if (isVisible) {
      const pageProperties = pageProps({ app });
      trackEvent({
        ...BUTTON_IMPRESSION,
        ...pageProperties,
        name: 'ViewReceipt',
        position: analyticsPosition.toString(),
      });
    }
  }

  onViewReceiptClick() {
    const { trackEvent, app, analyticsPosition } = this.props;
    const pageProperties = pageProps({ app });
    trackEvent({
      ...BUTTON_CLICK,
      ...pageProperties,
      name: 'ViewReceipt',
      position: analyticsPosition.toString(),
    });
  }

  onRateVisibilityChange(isVisible) {
    const { trackEvent, app, analyticsPosition } = this.props;
    if (isVisible) {
      const pageProperties = pageProps({ app });
      trackEvent({
        ...BUTTON_IMPRESSION,
        ...pageProperties,
        name: 'RateLocation',
        position: analyticsPosition.toString(),
      });
    }
  }

  onRateClick() {
    const { trackEvent, app, analyticsPosition } = this.props;
    const pageProperties = pageProps({ app });
    trackEvent({
      ...BUTTON_CLICK,
      ...pageProperties,
      name: 'RateLocation',
      position: analyticsPosition.toString(),
    });
  }

  render() {
    const { location, booking, brand, review, reviewBooking, selected } = this.props;
    if (!selected) { return null; }
    let memo;
    if (booking.expenseMemo) {
      memo = <div>Memo: <span className="text-weight-book">{booking.expenseMemo}</span></div>;
    }
    return (
      <div className={`row mock-table-row highlighted ${brand.isBestParking ? 'bp-highlighted' : null} light-background`}>
        <div className="col-xs-3">
          <div className="row">
            <div className="col-xs-offset-2 col-xs-10">
              <LocationImage
                location={location}
                type="thumbnail"
              />
            </div>
          </div>
        </div>
        <div className="col-xs-6">
          {memo}
          <div className="h6 light top bottom">Glad you found your happy space with <BrandName />!</div>
          <VisibilitySensor onChange={v => this.onRateVisibilityChange(v)} partialVisibility>
            <div onClick={() => this.onRateClick()}>
              <RateLocation booking={booking} review={review} reviewBooking={reviewBooking} />
            </div>
          </VisibilitySensor>
          
        </div>
        <div className="col-xs-3">
          <VisibilitySensor onChange={v => this.onViewReceiptVisibilityChange(v)} partialVisibility>
            <div onClick={() => this.onViewReceiptClick()}>
              <ViewReceipt
                booking={booking}
                brand={brand}
              />
            </div>
          </VisibilitySensor>
          <VisibilitySensor onChange={v => this.onBookNowVisibilityChange(v)} partialVisibility>
            <div onClick={() => this.onBookAgainClick()}>
              <BookAgain
                location={location}
                venueID={booking.venueId}
                booking={booking}
                brand={brand}
              />
            </div>
          </VisibilitySensor>
        </div>
      </div>
    );
  }
}

Details.propTypes = propTypes;
Details.defaultProps = defaultProps;
export default Details;
